import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import followupApi from "../../../api/followup";

const defaultState = () => ({
    prospectiveMember: [],
    pagination: {},
    confirmation: "",
    progress: false,
    konfirmResponse: {},
    alert: "",
    isSuccess: false,
    alertTitle: "Oops!",
});

const state = defaultState();

const getters = {};

const mutations = {
    listFollowUp(state, data) {
        state.prospectiveMember = [];
        state.pagination = {};
        state.prospectiveMember = data.data;
        state.pagination = data.pagination;
    },
    setProgress(state, data) {
        state.progress = data;
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = {};
        state.konfirmResponse = data;
    },
    setSuccess(state, alert) {
        state.isSuccess = true;
        state.alert = alert;
        state.alertTitle = "Berhasil";
    },
    setAlert(state, alert) {
        state.isSuccess = false;
        state.alert = alert;
        state.alertTitle = "Oops!";
    },
};
const actions = {
    async getFollowUp({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {};
            let parameter = "{";
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`;
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            followupApi.getFollowUpData(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit("listFollowUp", { data: "error", pagination: data.pagination });
                } else {
                    commit("listFollowUp", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            followupApi.getFollowUpData({ limit: value.limit, page: value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit("listFollowUp", { data: "error", pagination: data.pagination });
                } else {
                    commit("listFollowUp", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },
    async updateFollowUp({ commit }, value) {
        return new Promise((resolve, reject) => {
            commit(PROGRESS_START, null, { root: true });
            commit("setProgress", true);
            followupApi
                .updateFollowUp(value)
                .then((res) => {
                    if (res.data.code) {
                        commit("setSuccess", "Status Follow Up Berhasil Diperbarui");
                        commit("saveConfirmResponse", res.data);
                        commit("setProgress", false);
                    }
                    commit(PROGRESS_FINISH, null, { root: true });
                    resolve(res.data.message);
                })
                .catch((err) => {
                    const data = err.response.data.message;
                    commit("saveConfirmResponse", data);
                    commit("setProgress", false);
                    commit(PROGRESS_FAIL, null, { root: true });
                    reject(err.response);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
